import React from 'react';

const PreviewError = (error) => {
  return (
    <>
      {' '}
      <div>
        {' '}
        Sorry, we can't render your content entry right now due to the error
        below:{' '}
      </div>
      <div>error message: {error.error.message}</div>
    </>
  );
};

export default PreviewError;
